import { FunctionComponent } from "react";

const createNameSpacedComponent = <T extends React.ElementType, U extends Record<string, React.ElementType>>(
	mainComponent: T,
	composedComponents: U,
): T & U => {
	const composedComponent = { ...(mainComponent as FunctionComponent<any>) };
	Object.keys(composedComponents).forEach((key) => {
		(composedComponent as any)[key] = composedComponents[key];
	});
	return composedComponent as T & U;
};

export default createNameSpacedComponent